export enum AlbumFormat {
  Photo = 'photo',
  Text = 'text',
}
